<template>
  <b-container id="createFotoalbum">
    <b-container v-if="fotos.length > 0">
      <b-row>
        <b-col cols="6" md="4" xl="3" v-for="(file, index) in urls" :key="index">
          <b-card no-body>
            <!-- <b-card-header>{{file.name}}</b-card-header> -->
            <b-card-img :src="file.url"></b-card-img>
            <b-progress :id="file.name" :max="100" class="my-1"></b-progress>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <hr class="my-2">
    <b-form v-if="!fotoalbumStatus.creatingNeuesFotoalbum && !fotoalbumStatus.fotoalbumCreated && editable" @submit.prevent="addFotoalbum()" class="text-left">
      <b-form-group>
        <b-form-file
          id="foto-input"
          v-model="fotos"
          accept="image/*"
          class="my-3 fileInput"
          placeholder="Wähle Bilder für ein neues Fotoalbum aus..."
          multiple
          @change="showPreview"
        ></b-form-file>
      </b-form-group>

      <b-form-group>
        <b-form-input id="titel" v-model="titel" type="text" @change="validateInput()" required placeholder="Fotoalbum Name"></b-form-input>
      </b-form-group>

      <b-button id="submitFotoalbum" type="submit" variant="success" class="float-right" v-bind:disabled="validateFotos === false || validateTitel === false">Fotoalbum erstellen</b-button>
      <p>Ein Fotoalbum kann maximal 100 Fotos enthalten: <strong>{{ anzahlAusgewaehlt }}</strong> von <strong>max. 100</strong> Bilder ausgewählt.</p>
    </b-form>
    <div v-else-if="fotoalbumStatus.creatingNeuesFotoalbum" class="text-center">
      <b-spinner variant="danger" type="grow"></b-spinner>
    </div>
    <div v-else-if="fotoalbumStatus.fotoalbumCreated || !editable" class="text-center">
      <b-alert variant="success" show>
        <p>Die Bilder werden jetzt hochgeladen. Dies kann einige Minuten dauern.</p>
        <b-button @click="$bvModal.hide(`fotoalbumAnlegen`)" variant="outline-secondary">Anzeige schließen</b-button>
      </b-alert>
    </div>
    
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CreateFotoalbum',
  computed: mapGetters(['fotoalbumStatus', 'fotoalben']),
  methods: {
    ...mapActions(['createNeuesFotoalbum']),
    addFotoalbum () {
      const fotoalbum = {}
      fotoalbum.titel = this.titel
      fotoalbum.fotos = this.fotos

      this.createNeuesFotoalbum(fotoalbum)
        .then(() => {
          this.editable = false
          const toastData = {
            title: "",
            msg: "Ein neues Fotoalbum wurde erstellt.",
            variant: "success"
          };

          if (this.fotoalbumStatus.errMsg) {
            toastData.title = "Es ist etwas schief gelaufen.";
            toastData.msg = this.fotoalbumStatus.errMsg;
            toastData.variant = "danger";
          }

          this.$emit("createFotoalbumToast", toastData);

          // if (!this.fotoalbumStatus.errMsg) {
          //   this.$bvModal.hide(`fotoalbumAnlegen`);
          // }
        })
    },
    showPreview (e) {
      const files = e.target.files
      this.urls = []

      this.anzahlAusgewaehlt = files.length
      this.validateFotos = files.length > 0 && files.length < 100 ? true : false

      if(!this.validateFotos) {
        document.getElementById('foto-input').classList.add('is-invalid')
        document.getElementById('foto-input').classList.remove('is-valid')
      } else {
        document.getElementById('foto-input').classList.add('is-valid')
        document.getElementById('foto-input').classList.remove('is-invalid')
      }

      if (this.validateFotos) {
        files.forEach(file => {
          this.urls.push({name: file.name, url: URL.createObjectURL(file)})
        })
      }
    },
    validateInput () {
      this.validateTitel = this.titel.length > 2 ? true : false
    }
  },
  data () {
    return {
      titel: '',
      validateTitel: false,
      fotos: [],
      validateFotos: true,
      urls: [],
      editable: true,
      anzahlAusgewaehlt: 0
    }
  }
}
</script>

<style scoped>
.fileInput {
  overflow: hidden;
}
</style>